import { updateConversation } from 'core_main/api/conversations';
import { DescribeConversationParameters } from './types';
import { createUpdateConversationCallbackResponse } from './helpers';

export const describeConversation = (
  parameters: DescribeConversationParameters,
  cb,
) => {
  const requestParams = {
    conversationId: parameters?.conversationId,
    custom: parameters?.customAttributes,
  };

  return updateConversation(requestParams)
    .then((res) => {
      const callbackResponse = createUpdateConversationCallbackResponse(res);

      if (typeof cb === 'function') cb(callbackResponse);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error(`Failed to describe conversation:`, error);
    });
};
